export const DEFAULT_LANGUAGE = 'en'
export const FALLBACK_LANGUAGE = 'en'
export const SUPPORTED_LANGUAGES = ['en', 'fr', 'es']
export const SUPPORTED_LANGUAGES_NAME = {'en': 'English', 'fr': 'Français', 'es': 'española'}